import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TIndexHarmonizationReportItem {
  indexType: string;
  parentName: string;
  harmonizedLabel: string;
  organisationIndexNames: string[];
}

export interface IIndexHarmonizationReportItem
  extends TIndexHarmonizationReportItem {}

const IndexHarmonizationReportItem = Model(
  (model: TIndexHarmonizationReportItem): IIndexHarmonizationReportItem => {
    const _value: TIndexHarmonizationReportItem = Object.assign({}, model);
    let _model = {
      get indexType() {
        return _value.indexType;
      },
      set indexType(value) {
        _value.indexType = value;
      },
      get parentName() {
        return _value.parentName;
      },
      set parentName(value) {
        _value.parentName = value;
      },
      get harmonizedLabel() {
        return _value.harmonizedLabel;
      },
      set harmonizedLabel(value) {
        _value.harmonizedLabel = value;
      },
      get organisationIndexNames() {
        return _value.organisationIndexNames;
      },
      set organisationIndexNames(value) {
        _value.organisationIndexNames = value;
      },
    };

    return ValidatableObject<IIndexHarmonizationReportItem>(_model);
  }
);

export default IndexHarmonizationReportItem;
